import React, { useEffect, useState } from "react";
import EditPagePanelComponent from "./editPagePanel.component";
import { connect, useDispatch, useSelector } from "react-redux";
import { publishNewProduct } from "../../../redux/action/products.action";
import SavingDialog from "../../dialog/savingDialog";
import { setEditorMode } from "modules/product-mgmt/redux/slice/productPage.slice";
import { resetAvailableSurveys } from "modules/survey/redux/slice";
import { AccessRights } from "lib/constants/accessRights";
import { canAccess } from "../../../../profile/redux/selector/profile.selector";

function EditPagePanelContainer({
  children,
  enableEditorMode,
  publishNewProduct,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const lang = useSelector((state) => state.constant.languages);

  const hasSurveyAccess = useSelector((state) =>
    canAccess(state, AccessRights.Survey.LISTING_READ)
  );
  const hasLuckyDrawAccess = useSelector((state) =>
    canAccess(state, AccessRights.Campaign.LUCKY_DRAW_READ)
  );
  const hasLuckyDrawV2Access = useSelector((state) =>
    canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_READ)
  );
  const hasInstantLuckyDrawAccess = useSelector((state) =>
    canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_READ)
  );
  const hasLoyaltyProgramAccess = useSelector((state) =>
    canAccess(state, AccessRights.LoyaltyProgram.MODULE)
  );

  const hasCampaignAccess =
    hasSurveyAccess ||
    hasLuckyDrawAccess ||
    hasLuckyDrawV2Access ||
    hasInstantLuckyDrawAccess ||
    hasLoyaltyProgramAccess;

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAvailableSurveys());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    enableEditorMode();
  }, [enableEditorMode]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handlePublish = () => {
    publishNewProduct();
    setIsOpen(true);
  };

  return (
    <>
      <EditPagePanelComponent
        children={children}
        handlePublish={handlePublish}
        lang={lang}
        hasCampaignAccess={hasCampaignAccess}
        hasSurveyAccess={hasSurveyAccess}
        hasLuckyDrawAccess={hasLuckyDrawAccess}
        hasLuckyDrawV2Access={hasLuckyDrawV2Access}
        hasInstantLuckyDrawAccess={hasInstantLuckyDrawAccess}
        hasLoyaltyProgramAccess={hasLoyaltyProgramAccess}
      />
      <SavingDialog isOpen={isOpen} handleClose={handleClose} />
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  enableEditorMode: () => dispatch(setEditorMode(true)),
  publishNewProduct: () => dispatch(publishNewProduct()),
});

export default connect(null, mapDispatchToProps)(EditPagePanelContainer);
